import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { AlertService } from 'sce-core';
import { SearchService } from '../../search/search.service';
import { ConfirmDialogService } from 'sce-core';
import { ResourceService } from 'sce-core';
import { CoreServiceRegistry } from '../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../shared-service-registry';
import { ButtonItem } from '../../button/button.model';
import { SearchParams } from '../../search/models/search-params.model';
import { DataTableConfig } from '../../search/models/data-table-config';
import { SearchStatus } from '../../search/models/search-status.model';
import { SearchEvent } from '../../search/models/search-event';
import { NEW_SEARCH_EVENT, NEW_ROW_EVENT, REFRESH_SEARCH_EVENT } from '../../search/search-constants';
import { SearchCriteria, Condition, Clause } from '../../search/models/search-filter-model';
import { ModalService } from '../../services/modal.service';
import { WaveReleaseBackendService } from '../../../features/outbound/wave-release/wave-release-home/services/wave-release-backend.service';
import { PropertyChangeEvent, MANUAL_EDIT } from '../../models/property-change-event';
import { OrAndCellEditorComponent } from '../../../features/setup/customer/parameter-group/custom-aggrid-cells/orand-cell-editor/orand-cell-editor.component';
// tslint:disable-next-line:max-line-length
import { OrAndCellRendererComponent } from '../../../features/setup/customer/parameter-group/custom-aggrid-cells/orand-cell-renderer/orand-cell-renderer.component';
import { Subscription } from 'rxjs/Subscription';
import { PageDefinition } from '../../search/models/page-definition.model';
import { WaveReleaseDataEditorService } from '../../../features/outbound/wave-release/wave-release-home/services/wave-release-editor.service';

@Component({
  selector: 'lfwms-order-parameter-popup',
  templateUrl: './order-parameter-popup.component.html',
  styleUrls: ['./order-parameter-popup.component.css'],
  providers: [WaveReleaseBackendService]
})
export class OrderParameterPopupComponent implements OnInit {


  // Two searchServices are used one for asntd table and other for asndetailtd table
  public lookupSearchService: SearchService;
  public buildParmSearchService: SearchService;


  public confirmDialogService: ConfirmDialogService;
  public resourceService: ResourceService;
  /* Eventhough this variable is not needed here
   as it is provided in the action service where the popup is called,
    this variable must be oprovided to avoid --aot error*/
  public title: string;
  public cOptions: any[] = [];
  public buildParamDataMap: any = {};
  public buildParamMetaDataMap: any = {};

  // If this component needs to be reused then this variable can bve used
  public displayMode: string = 'E';
  private callbackFunction: any;
  private parentRef: any;
  public eventSubscription: Subscription;

  // The dataService is saem as parentdataService
  public dataService: any;
  public dataEditor: WaveReleaseDataEditorService;
  public metaDataFetched: boolean = false;
  public actionButtonsEditOrderParamTable: Array<ButtonItem> = [];
  public buildParmKey: string;
  public maxIdValueForDetailTable: any;
  constructor(public modalService: ModalService,
    private coreServiceRegistry: CoreServiceRegistry,
    public alertService: AlertService,
    private sharedServiceRegistry: SharedServiceRegistry,
    public backendService: WaveReleaseBackendService) {
    this.confirmDialogService = this.sharedServiceRegistry.confirmDialogService;
    this.resourceService = this.coreServiceRegistry.resourceService;
    this.actionButtonsEditOrderParamTable = [
      new ButtonItem('Add Row', this.resourceService.get('lbl_AddNewRow'), 'param_build_add', 'plus-circle', []),
      new ButtonItem('Delete_Main', this.resourceService.get('btn_delete'), 'param_build_del', 'trash', [
        new ButtonItem('Delete Line Item(s)', this.resourceService.get('btn_delete_line'), 'param_build_del', 'trash', []),
      ])
    ];
  }

  public ngOnInit() {
    this.eventSubscription = this.buildParmSearchService.receiveEvent().subscribe(($event: any) => {
      if ($event.type === NEW_ROW_EVENT) {
        this.handleAddNewRow($event);
      }
    });
  }


  public handleAddNewRow(event: any) {
    const defaultOrAndValue: string = 'AND';
    event.selectedRow.cells['orand'].cVal = defaultOrAndValue;
    event.selectedRow.cells['buildparmkey'].cVal = this.buildParmKey ? this.buildParmKey : '';
    event.selectedRow.cells['fieldname'].cOptions = [];
    this.buildParmSearchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
    this.handleAddNewLineItem(event);
  }

  public handleAddNewLineItem(event) {
    const pageDefinition: PageDefinition = this.buildParmSearchService.getPagedData().pageDefinition;


    this.buildParmSearchService.getMaxValueForIdProperty().subscribe((response: any) => {
      if (response && response.propertyValues && response.propertyValues.length > 0) {
        this.maxIdValueForDetailTable = response.propertyValues[0].cVal;
        this.initializeValuesForNewLineItem(event.selectedRow, this.maxIdValueForDetailTable);
        this.buildParmSearchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
      }
    });
    if (this.buildParmSearchService.getPagedData().pageRows.length >= pageDefinition.pageSize) {
      // if the current page has overflown, clear the max value so that it can be refetched in the next page
      this.maxIdValueForDetailTable = null;
    }

  }

  public initializeValuesForNewLineItem(newRow, maxIdValueForDetailTable) {
    let maxValue: string = '00000';
    const idProperty = 'buildparmlineno';
    this.buildParmSearchService.getPagedData().pageRows.forEach((row: any) => {
      if (!maxValue || maxValue < row.cells[idProperty].cVal) {
        maxValue = row.cells[idProperty].cVal;
      }
    });
    if (maxIdValueForDetailTable && maxValue < maxIdValueForDetailTable) {
      maxValue = maxIdValueForDetailTable;
    }
    const newLineNumber = (+maxValue) + 1;
    let newLineNoStr = '' + newLineNumber;
    while (newLineNoStr.length < 5) {
      newLineNoStr = '0' + newLineNoStr;
    }
    newRow.cells[idProperty].cVal = newLineNoStr;
  }

  public handleButtonActionForEditOrderParameterTable(action) {
    if (action === 'Add Row') {
      this.buildParmSearchService.addNewRowToModel();
    }
    if (action === 'Delete Line Item(s)') {
      this.deleteLineItem();
    }
  }


  public registerCallback(callback: any, parentRef: any) {
    this.callbackFunction = callback;
    this.parentRef = parentRef;
  }

  public initializeComponents(dataService, tableEditor, $event) {
    this.buildParmKey = ($event.selectedRow && $event.selectedRow.cells) ? $event.selectedRow.cells['buildParmKey'].cVal : '';
    /* Data editor is needed  for searching in tableheader filter */
    // From this event we will get the detail of which row we have clciked and thus the buildparmValue
    this.dataService = dataService;
    this.lookupSearchService = this.createSearchService('buildparmtd', '');
    this.buildParmSearchService = this.createSearchService('buildparmdettd', 'buildparmlineno');
    const searchCriteria: SearchCriteria = this.createSearchCriteria();
    const searchCriterisOrderParameterTable: SearchCriteria = this.createCriteriaForOrderParmTable();
    this.dataEditor = tableEditor;
    // LFWM-3191-fix to load buttons by privilege in popups.
    this.buildParmSearchService.searchParams.actionButtons =
    this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.actionButtonsEditOrderParamTable);
    this.lookupSearchService.searchParams.tableEditor = tableEditor;
    this.buildParmSearchService.searchParams.tableEditor = tableEditor;
    this.lookupSearchService.setSearchCriteria(searchCriteria);
    this.buildParmSearchService.setSearchCriteria(searchCriterisOrderParameterTable);
    this.buildParmSearchService.searchParams.dataTableConfig.hiddenPropertiesForTable = ['buildparmkey'];
    this.lookupSearchService.fetchMetadata().subscribe((metaData: any) => {
      this.metaDataFetched = true;
      /* building the map to provide dataBinding to variables based on metadata, which is used
       for displaying the dropdown options */
      this.cOptions = this.getCoptions(metaData);
      for (let i = 0; i < metaData.columnList.length; i++) {
        const propertyName = metaData.columnList[i].propertyName;
        if (propertyName === 'restriction01' || propertyName === 'restriction02' ||
          propertyName === 'restriction03' || propertyName === 'restriction04'
          || propertyName === 'restriction05') {
          metaData.columnList[i].values.forEach((element: any) => {
            if (element.key) {
              /* [LFWM-2869] - for restriction fields - should display the description
              element.value - key value pair [key - value]. so start postion is key.length + 3 ( - ).
              it will remove key,- and the empty space from the value. return only description */
              element.value = element.value.substr(element.key.length + 3);
            }
          });
        }
        const values = metaData.columnList[i].values;
        this.buildParamMetaDataMap[propertyName] = {
          cName: propertyName,
          cVal: '',
          cValPrev: '',
          values: values,
          IsEdited: false
        };
      }
      this.lookupSearchService.fetchSearchResults().subscribe((data: any) => {

        const rows: any = this.lookupSearchService.getPagedData().pageRows;
        for (let j = 0; j < rows.length; j++) {
          if (rows[j].cells['buildparmkey'].cVal === this.buildParmKey) {
            this.buildParamDataMap = rows[j];
            break;
          }
        }
        this.setupdatedCoption();
        this.lookupSearchService.searchStatus.hasResults = true;
        this.lookupSearchService.searchStatus.recordCount = this.lookupSearchService.pagedData.pageDefinition.recordCount;
        const event = new SearchEvent(NEW_SEARCH_EVENT);
        event.isSearchSuccess = true;
        this.lookupSearchService.publishEvent(event);
      });
    });
    this.buildParmSearchService.fetchMetadata().subscribe((metaData: any) => {
      this.buildParmSearchService.fetchSearchResults()
        .subscribe((data: any) => {
          this.buildParmSearchService.searchStatus.hasResults = true;
          this.buildParmSearchService.searchStatus.recordCount = this.buildParmSearchService.pagedData.pageDefinition.recordCount;
          const event = new SearchEvent(NEW_SEARCH_EVENT);
          event.isSearchSuccess = true;
          this.buildParmSearchService.publishEvent(event);
          // These steps were added because the fieldname column should be populated based on type
          const pageRows: any = this.buildParmSearchService.getPagedData().pageRows;
          this.dataEditor.populateRestrictedValues(pageRows, 'type');
        });
    });
  }
  public createCriteriaForOrderParmTable() {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition1 = this.createDefaultSearchCondition(1);
    defaultCondition1.isReadOnly = true;
    defaultCondition1.isMandatory = true;
    defaultCondition1.operator = null;
    const defaultClause1 = new Clause();
    defaultClause1.column = 'buildparmkey';

    defaultClause1.value = this.buildParmKey;
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = null;
    defaultCondition1.clauses = [defaultClause1];
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }
  public createSearchCriteria() {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition1 = this.createDefaultSearchCondition(1);
    defaultCondition1.isReadOnly = true;
    defaultCondition1.isMandatory = true;
    defaultCondition1.operator = null;
    const defaultClause1 = new Clause();
    defaultClause1.column = 'parmgroup';
    defaultClause1.value = this.dataService.waveSummarySearchParams['buildParmGroup'];
    defaultClause1.operation = '=';
    defaultClause1.logicalOperation = null;
    defaultCondition1.clauses = [defaultClause1];
    defaultSearchCriteria.conditions.push(defaultCondition1);
    return defaultSearchCriteria;
  }
  protected createDefaultSearchCondition(id) {
    const defaultCondition = new Condition();
    defaultCondition.id = id;
    defaultCondition.displayMode = 'VIEW';
    return defaultCondition;
  }

  /*
   *this method is call on change of values in detail page param list tab
   */
  public setupdatedCoptionOnvalueChange(key: any, sourceEvent?: any) {
    let newVal = null;
    if (sourceEvent !== null && sourceEvent !== undefined) {
      if ('string' === typeof sourceEvent) {
        newVal = sourceEvent;
      } else if ('object' === typeof sourceEvent) {
        newVal = sourceEvent['newVal'];
      }
    }

    if (newVal === null || newVal === undefined) {
      newVal = this.buildParamDataMap.cells[key].cVal;
    }
    // if the value has changed, send an event and check if the change can be accepted
    const event: PropertyChangeEvent = new PropertyChangeEvent();
    event.source = 'table-editor';
    event.type = MANUAL_EDIT;
    event.property = this.buildParamDataMap.cells[key].cName;
    event.value = newVal;
    // JIRA LFWM-1474 Fixes - current value and previous value of a dropdown element should not be the same value
    if (sourceEvent && sourceEvent.type && sourceEvent.type === 'dropdown') {
      event.previousValue = sourceEvent.prevVal;
    } else {
      event.previousValue = this.buildParamDataMap.cells[key].cVal;
    }
    const acceptChange: boolean = this.dataEditor.propertyValueChanged(event);
    // if the property change is to be rejected, do not set the is edited flag
    if (acceptChange) {
      this.buildParamDataMap.cells[key].isEdited = true;
      //  this.navService.preventNavigation = true;
      // if the event is from dropdown the current value is already set in this.buildParamDataMap.cells
      if (sourceEvent && sourceEvent.type && sourceEvent.type === 'dropdown') {
        this.buildParamDataMap.cells[key].cValPrev = sourceEvent.prevVal;
        this.setupdatedCoption();
      } else {
        this.buildParamDataMap.cells[key].cValPrev = this.buildParamDataMap.cells[key].cVal;
        this.buildParamDataMap.cells[key].cVal = newVal;
      }
    }
  }
  /*
   * this method is called to setCoptionsForRestriction i.e set coptions for the 5 restriction fields
   */
  public setupdatedCoption() {
    const restriction01 = this.buildParamDataMap.cells['restriction01'].cVal;
    const restriction02 = this.buildParamDataMap.cells['restriction02'].cVal;
    const restriction03 = this.buildParamDataMap.cells['restriction03'].cVal;
    const restriction04 = this.buildParamDataMap.cells['restriction04'].cVal;
    const restriction05 = this.buildParamDataMap.cells['restriction05'].cVal;
    this.buildParamDataMap.cells['restrictionValue01'].cVal =
      this.buildParamDataMap.cells['restriction01'].cVal ? this.buildParamDataMap.cells['restrictionValue01'].cVal : '';
    this.buildParamDataMap.cells['restrictionValue02'].cVal =
      this.buildParamDataMap.cells['restriction02'].cVal ? this.buildParamDataMap.cells['restrictionValue02'].cVal : '';
    this.buildParamDataMap.cells['restrictionValue03'].cVal =
      this.buildParamDataMap.cells['restriction03'].cVal ? this.buildParamDataMap.cells['restrictionValue03'].cVal : '';
    this.buildParamDataMap.cells['restrictionValue04'].cVal =
      this.buildParamDataMap.cells['restriction04'].cVal ? this.buildParamDataMap.cells['restrictionValue04'].cVal : '';
    this.buildParamDataMap.cells['restrictionValue05'].cVal =
      this.buildParamDataMap.cells['restriction05'].cVal ? this.buildParamDataMap.cells['restrictionValue05'].cVal : '';
    const selectedCoptions = [restriction01, restriction02, restriction03, restriction04, restriction05];
    const columnName = ['restriction01', 'restriction02', 'restriction03', 'restriction04', 'restriction05'];
    for (let restriction = 0; restriction < 5; restriction++) {
      this.setCoptionsForRestriction(columnName[restriction], selectedCoptions, restriction);
    }
  }
  /*
  * this method is called to setCoptionsForRestriction i.e set coptions for the 5 restriction field
  */
  public setCoptionsForRestriction(colName: string, selectedCoptionsList: any[], index: number) {
    const unSelectedCoptions: any[] = [];
    unSelectedCoptions.push(this.cOptions[0]);
    this.cOptions.forEach(keyValuePair => {
      if (keyValuePair.key && selectedCoptionsList.indexOf(keyValuePair.key) === -1) {
        unSelectedCoptions.push(keyValuePair);
      } else if (keyValuePair.key && keyValuePair.key === selectedCoptionsList[index]) {
        unSelectedCoptions.push(keyValuePair);
      }
    });
    this.buildParamMetaDataMap[colName].values = unSelectedCoptions;
  }
  /*
    * retrieve Coptions from previous tab(build param tab)
    */
  public getCoptions(metaData: any) {
    let cOptions: any[] = [];
    metaData.columnList.filter((columnList: any) => {
      if (columnList.propertyName === 'restriction01') {
        cOptions = columnList.values;
      }
    });
    return cOptions;
  }
  /*
 * this method is called to toggle the check box on select unselect
 */
  public toggleSelect(checkboxValue: string) {
    this.buildParamDataMap.cells['active'].cVal = checkboxValue === '0' ? '1' : '0';
    this.buildParamDataMap.cells['active'].isEdited = true;
  }

  private createSearchService(tableId: string, idProperty): SearchService {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.idProperty = idProperty;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    searchParams.defaultSearchColumn = '';
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.alertService;
    searchParams.tableEditor = this.dataEditor;
    searchParams.dataTableConfig.editable = true;
    /**
   * If the table is in View Mode make all columns as non editable
   * In the Edit Mode, make columns editable based on its metadata
   * In Create Mode, make all columns as editable
   *@paramdisplayType- The column displayType as in metadata
   */
    searchParams.dataTableConfig.isColumnEditable = function (params: any) {
      const componentRef = params.context.componentParent;
      // if the table is in view mode, do not make any column as editable
      if (['V', 'P'].indexOf(componentRef.tableMode) !== -1) {
        return false;
      }
      // enable the column only if it is an editable field in the metadata
      return (['E', 'EL', 'L', 'EA'].indexOf(componentRef.metaDataMap[params.colDef.colId].displayType) > -1);
    };
    if (tableId === 'buildparmdettd') {
      searchParams.dataTableConfig.columnEditorMapping['orand'] = OrAndCellEditorComponent;
      searchParams.dataTableConfig.columnRendererMapping['orand'] = OrAndCellRendererComponent;
    }
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    console.log(searchService);
    return searchService;
  }


  public getLabel(key: any) {
    return this.resourceService.get(key);
  }
  // Returns modified line items from the details table
  public getModifiedLineItems(): any[] {
    const editedRows = this.buildParmSearchService.getEditedRows();
    const modifiedLineItems = [];

    const detailIdProperty = 'buildparmlineno';
    if (editedRows.length === 0) {
      return editedRows;
    }
    /*LFWM-1054 updating the logic so as to incorporate all the line item properties even
    if only few properties are edited in that row*/

    this.buildParmSearchService.getPagedData().pageRows.forEach((row: any, index: any) => {
      const modifiedLineItem = [];
      if (row.isEdited) {

        // Copy Actual Values to BuildValue also [dummy columns used for build/refresh by SP]
        // "buildValue" -- copied before lineItems request oject is created.
        row.cells['buildValue'].cVal = row.cells['value'].cVal;

        Object.keys(row.cells).forEach((property: any) => {
          const cell = row.cells[property];
          modifiedLineItem.push({ cName: property, cVal: cell.cVal, cValOrig: cell.cValOrig, cValPrev: cell.cValPrev });
          // previous values are needed while forming the request
        });
        modifiedLineItem.push({ cName: detailIdProperty, cVal: row.cells[detailIdProperty].cVal });
        //  modifiedLineItem.push({ cName: primaryIdProperty, cVal: primaryProperties[primaryIdProperty].cVal });
        modifiedLineItems.push({ rIdx: index, cells: modifiedLineItem });

      }
    });
    return modifiedLineItems;

  }

  // Method used to save an entity
  public savePage() {
    let inValues: Array<any> = [];
    let isConditionValid: Boolean = true;
    let errMsg: String = '';
    let modifiedPropertiesArray: Array<any>;
    let modifiedArrayForRequest: Array<any>; // stores the entity details for saving
    const privilege = 'wv_rel_ord_parm_add';
    // The code for create flow is to be done later and integrate thehis component with order parameters tab
    modifiedPropertiesArray = this.getModifiedPrimaryProperties(this.buildParamDataMap.cells);
    const modifiedTableDetailsArray: any = this.getModifiedLineItems();
    if ((modifiedPropertiesArray.length === 0) && (modifiedTableDetailsArray.length === 0)) {
      const msg = 'msg_no_mod';
      this.alertService.clearAll().warn(this.resourceService.get(msg));
      return;
    }

    // START :: IN condition validation
    // Copy Actual Values to BuildValue also [dummy columns used for build/refresh by SP]
    // "buildValue" -- copied before lineItems request oject is created.
    this.buildParmSearchService.pagedData.pageRows.forEach(row => {
      if (row.isEdited) {
        isConditionValid = true;
        if ((row.cells['operator'].cVal === 'IN' || row.cells['operator'].cVal === 'NOT IN') && (row.cells['value'].cVal) !== null) {
          // for operator 'IN' & when there is a value including blank(!= null)
          inValues = [];
          inValues = row.cells['value'].cVal.split(',');
          if (!this.validateInConditionBeforeSave(inValues)) {
            isConditionValid = false;
            errMsg = 'err_validt_cnd_msg';
            this.alertService.error([this.resourceService.get(errMsg), row.cells['fieldname'].cVal + ' ' + row.cells['value'].cVal]);

          }
        } else if ((row.cells['operator'].cVal === '=' && (row.cells['value'].cVal) !== null)) {
          // LFWM-3212 - build order parameters - UI validatin for = operator
          inValues = row.cells['value'].cVal;
          if (!this.valiateEqualConditionBeforeSave(inValues)) {
            isConditionValid = false;
            errMsg = 'err_validt_e_msg';
            this.alertService.clearAll().error([this.resourceService.get(errMsg), row.cells['fieldname'].cVal + ' ' + row.cells['value'].cVal]);

          }
        } else if ((row.cells['operator'].cVal === 'IN SQL' || row.cells['operator'].cVal === 'NOT IN SQL') && (row.cells['value'].cVal) !== null) {
          // LFWM-3212 - build order parameters - UI validatin for IN SQL operator
          inValues = row.cells['value'].cVal;
          if (!this.validateInConditionBeforeSaveforInsql(inValues)) {
            isConditionValid = false;
            errMsg = 'err_validt_sql_msg';
            this.alertService.clearAll().error([this.resourceService.get(errMsg), row.cells['fieldname'].cVal + ' ' + row.cells['value'].cVal]);

          }
        } else if ((row.cells['operator'].cVal === 'LIKE' || row.cells['operator'].cVal === 'NOT LIKE') && (row.cells['value'].cVal) !== null) {
          inValues = row.cells['value'].cVal;
          if (!this.valiateEqualConditionBeforeSave(inValues)) {
            isConditionValid = false;
            errMsg = 'err_validt_l_msg';
            this.alertService.clearAll().error([this.resourceService.get(errMsg), row.cells['fieldname'].cVal + ' ' + row.cells['value'].cVal]);

          }
        }
      }
    });
    if (!isConditionValid) {
      return;
    }

    // END :: IN condition validation


    const requestArrayFinal: Array<any> = [];
    modifiedArrayForRequest = this.getEntityValuesList();
    const requestAccordion = {
      'moduleProperties': modifiedArrayForRequest,
      'screenType': 'buildparmtd',
      'detailItems': [],
      'privilege': privilege
    };
    requestArrayFinal.push(requestAccordion);

    const dataTableRequest: any = this.getLineItemsList(modifiedTableDetailsArray);
    for (let j = 0; j < dataTableRequest.length; j++) {
      const requestTableLineItem = {
        'moduleProperties': dataTableRequest[j]['cells'],
        'screenType': 'buildparmdettd',
        'detailItems': [],
        'privilege': privilege
      };
      requestArrayFinal.push(requestTableLineItem);
    }

    return this.backendService.saveEntityforUpdateWithPrivilege(requestArrayFinal)
      .subscribe((response) => {
        // We are not dealing with the response here, we would send the response to parent function and deal it there
        const request: any = {
          response: response
        };
        this.callbackFunction(this.parentRef, request);
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
  }

  // Method for jira 1855 - Build order parameters - UI validation for order parameter
  private validateInConditionBeforeSave(inParam): boolean {
    let isValid: boolean = true;
    for (const val of inParam) {
      if (!(
        val.startsWith(`'`) && val.endsWith(`'`) // enclosed in single quotes
        && val.length >= 2  // not just one single-quotes
        && (val.indexOf(`'`, 1) === val.lastIndexOf(`'`))    // no single-quotes in between
      )) {
        isValid = false;
      }
    }
    return isValid;
  }

  // LFWM-3212 - build order parameter - UI Validation for equal operator
  private valiateEqualConditionBeforeSave(inParam): boolean {
    let isValid: boolean = true;
    if (!(
      inParam.startsWith(`'`)
      && inParam.endsWith(`'`)
      && !inParam.includes(',')// enclosed in '
    )) {
      isValid = false;
    }
    if (
      !inParam.startsWith(`'`) &&
      !inParam.endsWith(`'`)
    ) {
      isValid = true;
    }
    return isValid;
  }

  // LFWM-3212 - build order parameters - UI validatin for IN SQL operator
  private validateInConditionBeforeSaveforInsql(inParam): boolean {
    let isValid: boolean = true;
    if (!(
      inParam.startsWith(`(`) && inParam.endsWith(`)`) // enclosed in brackets
    )) {
      isValid = false;
    }
    return isValid;
  }

  // returns the modified primary properties of the entity
  public getModifiedPrimaryProperties(primaryProperties: any) {
    const dataArray: Array<any> = [];
    const dataOrderParams = Object.keys(primaryProperties);
    /*LFWM-1054 updating the logic so as to incorporate all the properties even if only few properties are
    edited*/
    let haveEditedData: boolean = false;

    for (let i = 0; i < dataOrderParams.length; i++) {
      if (primaryProperties[dataOrderParams[i]].isEdited) {
        haveEditedData = true;
        break;
      }
    }
    if (haveEditedData) {
      dataOrderParams.forEach((property: string) => {
        const propertyVal = primaryProperties[property];
        if (propertyVal) {
          dataArray.push({ cName: property, cVal: propertyVal.cVal });
        }
      });
    }
    return dataArray;
  }

  /*This method forms the request for saving the entity details. While editing an existing entity,
    the original data should also be sent prefixed with _original, along with the edited data
    If it is a new entity the prefix can be avoided*/
  public getEntityValuesList() {
    let data;
    const accordionDetails = [];
    const typeName = 'original_';
    Object.keys(this.buildParamDataMap.cells).forEach((property: any) => {
      data = this.buildParamDataMap.cells[property];
      if (this.displayMode === 'E') {
        if (data.isEdited) {// for fields which are edited
          /*LFWM-1733 this.dataService.originalDataMap[property].cVal will give the original value
          of that particular field, cValPrev will give the previosly modified value and
          not the original value.The original value should also be send along with the req */
          // LFWM-1761 : Code fix
          accordionDetails.push({ cName: typeName + data.cName, cVal: data.cValOrig });
          accordionDetails.push({ cName: data.cName, cVal: data.cVal });
        } else {
          if (!(this.buildParamDataMap.cells[data.cName] &&
            (this.buildParamDataMap.cells[data.cName].displayType === 'H') && (data.cVal === null || data.cVal === undefined))) {
            accordionDetails.push({ cName: typeName + data.cName, cVal: data.cVal });
            accordionDetails.push({ cName: data.cName, cVal: data.cVal });
          }
        }
      } else { // for new entity
        accordionDetails.push({ cName: data.cName, cVal: data.cVal });
      }
    });
    if (this.dataService.displayMode === 'C') {
      accordionDetails.push({ cName: 'isNewItem', cVal: true });
    }
    return accordionDetails;
  }


  public getLineItemsList(modifiedLineItems) {
    const requestList: Array<any> = []; // stores the formatted line items
    let selectedLineItem;
    modifiedLineItems.forEach((row: any, index: any) => {
      selectedLineItem = [];
      let isNewItem = false;
      (row.cells).forEach((cell: any) => {
        if (cell.cName === 'isNewItem' && cell.cVal) {
          isNewItem = true;
        }
      });
      // const isNewItem: boolean = (row.cells['isNewItem'] && row.cells['isNewItem'].cVal) ? true : false;
      let typeName = '';
      if (!isNewItem) {
        typeName = 'original_';
        (row.cells).forEach((cell: any) => {
          if (cell.cName !== 'isNewItem') {
            if ((cell.cValOrig !== undefined) && (cell.cValOrig !== cell.cVal)) { // for fields which are edited
              selectedLineItem.push({ cName: typeName + cell.cName, cVal: cell.cValOrig });
              selectedLineItem.push({ cName: cell.cName, cVal: cell.cVal });
            } else { // for fields which are not edited
              selectedLineItem.push({ cName: typeName + cell.cName, cVal: cell.cVal });
              selectedLineItem.push({ cName: cell.cName, cVal: cell.cVal });
            }
          } else { // for new line items
            selectedLineItem.push({ cName: cell.cName, cVal: cell.cVal });
          }
        });
      } else {
        (row.cells).forEach((cell: any) => {
          selectedLineItem.push({ cName: cell.cName, cVal: cell.cVal });
        });
      }
      requestList.push({ rIdx: index, cells: selectedLineItem });
    });
    return requestList;
  }


  // Method used to delete the selected Line Items
  public deleteLineItem() {
    // 'noOfLineItems' variable is used to hold total number of records available in the grid
    const noOfLineItems: any = this.buildParmSearchService.getPagedData().pageDefinition.recordCount;
    // 'selectedRows' variable is used to hold the rows selected by the user
    const selectedRows: Array<any> = this.buildParmSearchService.getSelectedRows();
    const privilege = 'wv_rel_ord_parm_del';
    // Below validation is used to throw error message if there is no data available in the grid
    if (noOfLineItems === 0) {
      const errorMsg = 'msg_no_detail_op';
      this.alertService.clearAll().error(this.resourceService.get(errorMsg));
      return;
    }
    // 'lineItemProp' variable is used to hold the primary property of the grid
    const lineItemProp: string = this.buildParmSearchService.searchParams.idProperty;
    // If user selects one or more records, needs to show a confirmation dialog box otherwise throw an error message
    if (selectedRows.length > 0) {
      const dialogMsg = this.dataService.createAlertMessage(this.resourceService.get('msg_itm_conf_del'));
      this.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            // 'itemNumber' variable is used to hold the primary propery value
            let itemNumber: string = null;
            // Since we only have single line item delete and not delete all items
            if (this.buildParmSearchService.getSelectedRows().length > 0) {
              itemNumber = this.buildParmSearchService.getSelectedRows()[0].cells['buildparmkey'].cVal;
            }

            // 'existingLineItemNumbers' variable is used to hold selected rows which has inserted into DB
            const existingLineItemNumbers: Array<any> = [];
            selectedRows.forEach((row: any) => {
              existingLineItemNumbers.push({
                'value': row.cells[lineItemProp].cVal,
                'index': row.rIdx
              });
            });
            // If user has selected any rows ,which has entry in DB then invoke 'Setup' delete API to delete the corresponding entry
            if (existingLineItemNumbers.length > 0) {
              this.backendService.deleteSelectedLineItemFromEntityWithPriv(itemNumber,
                existingLineItemNumbers, lineItemProp, privilege)
                .subscribe((resp: any) => {
                  if (resp['statusCode'] !== undefined && resp['statusCode'] !== null) {
                    if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                      const successMsg = this.resourceService.get('msg_del_itm_succ');
                      this.alertService.clearAll();
                      this.alertService.success(this.resourceService.get(successMsg));
                      // code to reload the  detail grid
                      this.reloadDetailTable();
                    } else {
                      this.alertService.clearAll();
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
                    }
                  } else {
                    if (resp.error) {
                      this.alertService.clearAll();
                      this.alertService.error(this.resourceService.translateServerResponse(resp.statusMessage));
                    }
                  }
                }, (error) => {
                  this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
                });
            }
          }
        });
    } else {
      this.alertService.clearAll();
      const errorMsg = 'msg_sel_detail_op';
      this.alertService.error(this.resourceService.get(errorMsg));
    }
  }

  public reloadDetailTable(reInitializeButtons?: boolean) {
    this.buildParmSearchService.performSearch();
    this.buildParmSearchService.receiveEvent().subscribe((event: SearchEvent) => {
      if (event.type === NEW_SEARCH_EVENT) {
        const pageRows = this.buildParmSearchService.getPagedData().pageRows;
        this.dataEditor.populateAllRestrictedValues(pageRows);
        this.dataEditor.populateRestrictedValues(pageRows, 'type');
      }
    });
  }

}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/order-parameter-popup/order-parameter-popup.component.ts